import { render } from "./copyright-terms-modal.html?vue&type=template&id=c5fdfee4&ts=true"
import script from "./copyright-terms-modal.ts?vue&type=script&lang=ts"
export * from "./copyright-terms-modal.ts?vue&type=script&lang=ts"

import "./copyright-terms-modal.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/runner/work/legacy_vue_store/legacy_vue_store/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__